import React from 'react';
import ProjectsGraphQlController from '../../../controllers/projectsGraphQl';
import { gql } from '@apollo/client';
import DatePicker from 'react-datepicker';
import { ReactComponent as PlusIcon } from '../../../assets/svg/plus-gray.svg';
import InputHeader from '../global/inputwithHeader';
import { ReactComponent as CloseIcon } from '../../../assets/svg/modal-close.svg';
import CustomDateInput from '../global/customDateInput';
import { ReactComponent as CriticalP } from '../../../assets/svg/critical_priority.svg';
import { ReactComponent as HighP } from '../../../assets/svg/high_priority.svg';
import { ReactComponent as LowP } from '../../../assets/svg/low_priority.svg';
import { ReactComponent as MediumP } from '../../../assets/svg/medium_priority.svg';
import _, { forEach } from 'lodash';
import { ReactComponent as Minus } from '../../../assets/svg/minus-circle.svg';
import { withRouter } from '../../../services/withRoute';

import Modal from '../../components/modals';
import Select from 'react-select';

import jwt_decode from 'jwt-decode';

import moment from 'moment';
import jwtDecode from 'jwt-decode';
const getProjectsOptions = gql`
	query VendorsProjects($workspaceIds: [String!], $filters: projectsListFiltersInput) {
		vendorsProjects(workspaceIds: $workspaceIds, filters: $filters) {
			data {
				id
				title
			}
		}
	}
`;
const getDeliverableOptions = gql`
	query VendorDeliverablesList($filters: DeliverablesListFiltersInput) {
		vendorDeliverablesList(filters: $filters) {
			data {
				id
				title
			}
		}
	}
`;
const createTask = gql`
	mutation CreateDeliverableTask(
		$projectId: ID!
		$tenantId: ID!
		$scopeId: ID!
		$createTaskInput: TaskInput!
	) {
		createDeliverableTask(
			projectId: $projectId
			tenantId: $tenantId
			scopeId: $scopeId
			createTaskInput: $createTaskInput
		) {
			id
		}
	}
`;
const createGenTask = gql`
	mutation RootMutation($createTaskInput: TaskInput!) {
		createGeneralTask(createTaskInput: $createTaskInput) {
			id
		}
	}
`;
const createWorkspaceTask = gql`
	mutation createWorkspaceTask($tenantId: ID!, $createTaskInput: TaskInput!) {
		createWorkspaceTask(
			tenantId: $tenantId

			createTaskInput: $createTaskInput
		) {
			id
		}
	}
`;
const createProjectTask = gql`
	mutation createProjectTask($projectId: ID!, $tenantId: ID!, $createTaskInput: TaskInput!) {
		createProjectTask(
			projectId: $projectId
			tenantId: $tenantId

			createTaskInput: $createTaskInput
		) {
			id
		}
	}
`;
class CreateTask extends ProjectsGraphQlController {
	constructor(props) {
		super(props);
		this.state = {
			workspace: null,
			selectedworkspace: null,
			project: null,
			selectedproject: null,
			deliverable: null,
			isChecked: false,
			nextState: false,
			taskSelectType: '',

			selecteddeliverable: null,
			projectsOptions: [],
			deliverableOptions: [],
			checkDeliverable: false,
			checkGeneral: false,
			checkWorkspace: false,
			checkProject: false,

			dueDate: null,
			selecteddueDate: null,
			description: null,
			priority: null,
			status: null,
			assignedTo: null,
			description: null,
			selectedassignedTo: null,

			selectedStatus: null,
			selectedpriority: null,
			priorityOptions: [
				{
					value: 'critical',
					label: (
						<span style={{ display: 'flex' }}>
							<span
								className="task-prio-opts"
								style={{
									display: 'flex',
									flexDirection: 'column',
								}}
							>
								<CriticalP />
							</span>
							<span>Critical</span>
						</span>
					),
				},
				{
					value: 'high',
					label: (
						<span>
							<span className="task-prio-opts">
								<HighP />
							</span>
							<span>High</span>
						</span>
					),
				},
				{
					value: 'medium',
					label: (
						<span>
							<span className="task-prio-opts">
								<MediumP />
							</span>
							<span>Medium</span>
						</span>
					),
				},
				{
					value: 'low',
					label: (
						<span>
							<span className="task-prio-opts">
								<LowP />
							</span>
							<span>Low</span>
						</span>
					),
				},
			],
			statusPriorityOptions: [
				{
					label: (
						<span style={{ display: 'flex', alignItems: 'center' }}>
							<span className="delivarableStatusCheck">
								<b style={{ backgroundColor: '#9F4DB7', marginRight: '15px' }}></b>
							</span>

							<span className="status-option-text">To Do</span>
						</span>
					),
					value: 'todo',
				},

				{
					label: (
						<span style={{ display: 'flex', alignItems: 'center' }}>
							<span className="delivarableStatusCheck">
								<b style={{ backgroundColor: '#5383EC', marginRight: '15px' }}></b>
							</span>

							<span className="status-option-text">In Progress</span>
						</span>
					),
					value: 'inProgress',
				},
				{
					label: (
						<span style={{ display: 'flex', alignItems: 'center' }}>
							<span className="delivarableStatusCheck">
								<b style={{ backgroundColor: '#8EE2C7', marginRight: '15px' }}></b>
							</span>

							<span className="status-option-text">In Review</span>
						</span>
					),
					value: 'inReview',
				},
				{
					label: (
						<span style={{ display: 'flex', alignItems: 'center' }}>
							<span className="delivarableStatusCheck">
								<b style={{ backgroundColor: '#479A5F', marginRight: '15px' }}></b>
							</span>

							<span className="status-option-text">Done</span>
						</span>
					),
					value: 'done',
					color: '#FF8B00',
				},
			],
		};
	}
	handleCloseModal = () => {
		this.props.handleClose();
	};
	handleCheckboxChange = (tasktype) => {
		this.setState({
			// checkDeliverable
			[`check${tasktype}`]: !this.state[`check${tasktype}`],
			taskSelectType: this.state.taskSelectType === tasktype ? '' : tasktype,
		});
		if (tasktype === 'Deliverable') {
			this.setState({
				checkGeneral: false,
				checkWorkspace: false,
				checkProject: false,
			});
		} else if (tasktype === 'General') {
			this.setState({
				checkDeliverable: false,
				checkWorkspace: false,
				checkProject: false,
			});
		} else if (tasktype === 'Workspace') {
			this.setState({
				checkDeliverable: false,
				checkGeneral: false,
				checkProject: false,
			});
		} else if (tasktype === 'Project') {
			this.setState({
				checkDeliverable: false,
				checkGeneral: false,
				checkWorkspace: false,
			});
		}
	};
	isDisabled = () => {
		if (this.state.nextState === false) {
			return this.state.taskSelectType.length === 0;
		} else if (this.state.nextState === true) {
			return this.state.taskSelectType === 'Deliverable'
				? this.state.workspace === null ||
						this.state.project === null ||
						this.state.deliverable === null ||
						this.state.description === null ||
						this.state.priority === null ||
						this.state.status === null
				: this.state.taskSelectType === 'General'
				? this.state.description === null ||
				  this.state.priority === null ||
				  this.state.status === null
				: this.state.taskSelectType === 'Project'
				? this.state.workspace === null ||
				  this.state.project === null ||
				  this.state.description === null ||
				  this.state.priority === null ||
				  this.state.status === null
				: this.state.workspace === null ||
				  this.state.description === null ||
				  this.state.priority === null ||
				  this.state.status === null;
		}
	};

	handleEventChange = (e, name) => {
		if (name === 'dueDate') {
			this.setState({
				selecteddueDate: parseInt(moment(e).format('yyyyMMDD')),
				dueDate: moment(e).format('yyyyMMDD'),
			});
		} else if (name === 'description') {
			this.setState({
				[name]: e.target.value,
			});
		} else {
			this.setState({
				[name]: e.value,
				[`selected${name}`]: e,
			});
			if (name === 'workspace') {
				this.getProjectsOptions(getProjectsOptions, {
					workspaceIds: [e.label],
					filters: {
						limit: 1000,
						page: 1,
					},
				});
			}
			if (name === 'project') {
				this.getDeliverableOptions(getDeliverableOptions, {
					filters: {
						limit: 1000,
						page: 1,
						projectId: e.value,
					},
				});
			}
		}
	};
	createTaskApiCall = () => {
		if (this.state.taskSelectType === 'Deliverable') {
			let json = {
				projectId: this.state.project,
				tenantId: this.state.workspace,
				scopeId: this.state.deliverable,
				createTaskInput: {
					title: this.state.description,
					priority: this.state.priority,
					status: this.state.status,
				},
			};

			if (this.state.selectedassignedTo !== null) {
				json = {
					...json,
					createTaskInput: {
						...json.createTaskInput,
						assignedTo: {
							id: this.state.selectedassignedTo.value,
							name: this.state.selectedassignedTo.label,
						},
					},
				};
			}
			if (this.state.selecteddueDate !== null) {
				json = {
					...json,
					createTaskInput: {
						...json.createTaskInput,
						dueDate: this.state.selecteddueDate,
					},
				};
			}

			this.createTask(createTask, json).then(() => {
				this.handleCloseModal();
			});
		} else if (this.state.taskSelectType === 'General') {
			let json = {
				createTaskInput: {
					title: this.state.description,
					priority: this.state.priority,
					status: this.state.status,
				},
			};

			if (this.state.selectedassignedTo !== null) {
				json = {
					...json,
					createTaskInput: {
						...json.createTaskInput,
						assignedTo: {
							id: this.state.selectedassignedTo.value,
							name: this.state.selectedassignedTo.label,
						},
					},
				};
			}
			if (this.state.selecteddueDate !== null) {
				json = {
					...json,
					createTaskInput: {
						...json.createTaskInput,
						dueDate: this.state.selecteddueDate,
					},
				};
			}

			this.createGenTask(createGenTask, json).then(() => {
				this.handleCloseModal();
			});
		} else if (this.state.taskSelectType === 'Workspace') {
			let json = {
				tenantId: this.state.workspace,

				createTaskInput: {
					title: this.state.description,
					priority: this.state.priority,
					status: this.state.status,
				},
			};

			if (this.state.selectedassignedTo !== null) {
				json = {
					...json,
					createTaskInput: {
						...json.createTaskInput,
						assignedTo: {
							id: this.state.selectedassignedTo.value,
							name: this.state.selectedassignedTo.label,
						},
					},
				};
			}
			if (this.state.selecteddueDate !== null) {
				json = {
					...json,
					createTaskInput: {
						...json.createTaskInput,
						dueDate: this.state.selecteddueDate,
					},
				};
			}

			this.createWorkspaceTask(createWorkspaceTask, json).then(() => {
				this.handleCloseModal();
			});
		} else if (this.state.taskSelectType === 'Project') {
			let json = {
				projectId: this.state.project,
				tenantId: this.state.workspace,

				createTaskInput: {
					title: this.state.description,
					priority: this.state.priority,
					status: this.state.status,
				},
			};

			if (this.state.selectedassignedTo !== null) {
				json = {
					...json,
					createTaskInput: {
						...json.createTaskInput,
						assignedTo: {
							id: this.state.selectedassignedTo.value,
							name: this.state.selectedassignedTo.label,
						},
					},
				};
			}
			if (this.state.selecteddueDate !== null) {
				json = {
					...json,
					createTaskInput: {
						...json.createTaskInput,
						dueDate: this.state.selecteddueDate,
					},
				};
			}

			this.createProjectTask(createProjectTask, json).then(() => {
				this.handleCloseModal();
			});
		}
	};

	render() {
		return (
			<Modal
				handleClose={() => this.handleCloseModal()}
				show={this.props.show}
				modalType={'center'}
				isOverflowVisible={true}
				// custClass={_.has(this.props, 'custClass') ? this.props.custClass : ''}
			>
				<div className="busy-modal">
					<div className="bm-header2">
						<div></div>
						<p>
							{' '}
							{this.state.nextState === false
								? 'New Task'
								: 'New ' + this.state.taskSelectType + ' Task'}
						</p>
						<CloseIcon
							style={{
								cursor: 'pointer',
							}}
							onClick={() => this.handleCloseModal()}
						/>
					</div>
					<div className="bm-body2">
						{this.state.nextState ? (
							<div
								style={{
									display: 'flex',
									flexDirection: 'column',
								}}
							>
								{this.state.taskSelectType === 'Deliverable' ? (
									<>
										{' '}
										<div
											className="floating-select-container"
											style={{
												display: 'block',
												float: 'left',
												margin: '30px 0px',
												zIndex: 68768681,
											}}
										>
											<label>Workspace*</label>
											<Select
												className="cost-select-container w-100p fixed-select-container"
												classNamePrefix="cost-select"
												options={this.props.workspacesOptions}
												onChange={(e) =>
													this.handleEventChange(e, 'workspace')
												}
												isSearchable={true}
											/>
										</div>
										<div
											className="floating-select-container"
											style={{
												display: 'block',
												float: 'left',
												margin: '30px 0px',
												zIndex: 6876868,
											}}
										>
											<label>Project*</label>
											<Select
												className="cost-select-container w-100p fixed-select-container"
												classNamePrefix="cost-select"
												options={this.state.projectsOptions}
												onChange={(e) =>
													this.handleEventChange(e, 'project')
												}
												isSearchable={true}
											/>
										</div>
										<div
											className="floating-select-container"
											style={{
												display: 'block',
												float: 'left',
												margin: '30px 0px',

												zIndex: 999999,
											}}
										>
											<label>Deliverable*</label>
											<Select
												className="cost-select-container w-100p fixed-select-container"
												classNamePrefix="cost-select"
												options={this.state.deliverableOptions}
												onChange={(e) =>
													this.handleEventChange(e, 'deliverable')
												}
												isSearchable={true}
											/>
										</div>
									</>
								) : null}
								{this.state.taskSelectType === 'Workspace' ? (
									<>
										<div
											className="floating-select-container"
											style={{
												display: 'block',
												float: 'left',
												margin: '30px 0px',
												zIndex: 68768681,
											}}
										>
											<label>Workspace*</label>
											<Select
												className="cost-select-container w-100p fixed-select-container"
												classNamePrefix="cost-select"
												options={this.props.workspacesOptions}
												onChange={(e) =>
													this.handleEventChange(e, 'workspace')
												}
												isSearchable={true}
											/>
										</div>
									</>
								) : null}
								{this.state.taskSelectType === 'Project' ? (
									<>
										{' '}
										<div
											className="floating-select-container"
											style={{
												display: 'block',
												float: 'left',
												margin: '30px 0px',
												zIndex: 68768681,
											}}
										>
											<label>Workspace*</label>
											<Select
												className="cost-select-container w-100p fixed-select-container"
												classNamePrefix="cost-select"
												options={this.props.workspacesOptions}
												onChange={(e) =>
													this.handleEventChange(e, 'workspace')
												}
												isSearchable={true}
											/>
										</div>
										<div
											className="floating-select-container"
											style={{
												display: 'block',
												float: 'left',
												margin: '30px 0px',
												zIndex: 6876868,
											}}
										>
											<label>Project*</label>
											<Select
												className="cost-select-container w-100p fixed-select-container"
												classNamePrefix="cost-select"
												options={this.state.projectsOptions}
												onChange={(e) =>
													this.handleEventChange(e, 'project')
												}
												isSearchable={true}
											/>
										</div>
									</>
								) : null}

								<div
									style={{
										display: 'block',
										float: 'left',
										margin: '30px 0px',
										marginBottom: '0px',
										zIndex: 1,
									}}
								>
									<InputHeader
										type="text"
										width="100%"
										name="description"
										value={this.state.description}
										readOnly={false}
										onChange={(e) => {
											this.handleEventChange(e, 'description');
										}}
										isInputError={false}
										label="Description*"
									/>
								</div>
								<div
									style={{
										width: '100%',
										// marginTop: '-30px',

										zIndex: '999998',
									}}
								>
									<DatePicker
										selected={
											this.state.dueDate !== null
												? moment(
														this.state.dueDate.toString(),
														'YYYYMMDD',
												  ).toDate()
												: ''
										}
										onChange={(e) => {
											this.handleEventChange(e, 'dueDate');
										}}
										dateFormat="dd/MM/yyyy"
										placeholderText="dd / mm / yyyy"
										openToDate={new Date()}
										customInput={<CustomDateInput customLabel="Due Date" />}
										wrapperClassName={`w-100p`}
									/>
								</div>
								<div
									className="floating-select-container"
									style={{
										marginTop: '10px',

										zIndex: 99999,
									}}
								>
									<label>Assigned To</label>
									<Select
										className="cost-select-container w-100p fixed-select-container"
										classNamePrefix="cost-select"
										options={this.props.assignedToOptions}
										onChange={(e) => this.handleEventChange(e, 'assignedTo')}
										isSearchable={true}
										menuPosition={'fixed'}
									/>
								</div>

								<div
									className="floating-select-container"
									style={{
										zIndex: '7999',
										marginTop: '60px',
									}}
								>
									<label>Priority*</label>
									<Select
										className="cost-select-container zIndex31 w-100p"
										classNamePrefix="cost-select"
										options={this.state.priorityOptions}
										onChange={(e) => this.handleEventChange(e, 'priority')}
										isSearchable={true}
										menuPosition={'fixed'}
									/>
								</div>
								<div
									className="floating-select-container"
									style={{
										marginTop: '30px',
									}}
								>
									<label>Status*</label>
									<Select
										className="cost-select-container zIndex31 w-100p"
										classNamePrefix="cost-select"
										options={this.state.statusPriorityOptions}
										onChange={(e) => this.handleEventChange(e, 'status')}
										isSearchable={true}
										menuPosition={'fixed'}
									/>
								</div>
							</div>
						) : (
							<div
								style={{
									display: 'flex',
									flexDirection: 'column',
								}}
							>
								<label
									style={{
										textAlign: 'center',
									}}
									className="task-option-label"
								>
									Please select which type of task you would like to create
								</label>
								<div
									style={{
										display: 'flex',
										flexDirection: 'column',
										gap: '16px',
										marginTop: '20px',
									}}
								>
									<div
										className="create-task-checkbox-container"
										style={{
											background: this.state.checkGeneral
												? '#413B48'
												: 'none',
										}}
									>
										<input
											type="checkbox"
											checked={this.state.checkGeneral}
											onChange={() => this.handleCheckboxChange('General')}
											style={{
												height: '20px',
												width: '20px',
												borderRadius: '4px',
												border: '1.5px solid #707070',
												backgroundColor: this.state.checkGeneral
													? '#9256D9'
													: '#707070',
											}}
										/>
										<label className="create-task-checkbox-text">
											General task
										</label>
									</div>
									<div
										className="create-task-checkbox-container"
										style={{
											background: this.state.checkWorkspace
												? '#413B48'
												: 'none',
										}}
									>
										<input
											type="checkbox"
											checked={this.state.checkWorkspace}
											onChange={() => this.handleCheckboxChange('Workspace')}
											style={{
												height: '20px',
												width: '20px',
												borderRadius: '4px',
												border: '1.5px solid #707070',
												backgroundColor: this.state.checkWorkspace
													? '#9256D9'
													: 'none',
											}}
										/>
										<label className="create-task-checkbox-text">
											Workspace task
										</label>
									</div>
									<div
										className="create-task-checkbox-container"
										style={{
											background: this.state.checkDeliverable
												? '#413B48'
												: 'none',
										}}
									>
										<input
											type="checkbox"
											checked={this.state.checkDeliverable}
											onChange={() =>
												this.handleCheckboxChange('Deliverable')
											}
											style={{
												height: '20px',
												width: '20px',
												borderRadius: '4px',
												border: '1.5px solid #707070',
												backgroundColor: this.state.checkDeliverable
													? '#9256D9'
													: 'none',
											}}
										/>
										<label className="create-task-checkbox-text">
											Deliverable task
										</label>
									</div>
									<div
										className="create-task-checkbox-container"
										style={{
											background: this.state.checkProject
												? '#413B48'
												: 'none',
										}}
									>
										<input
											type="checkbox"
											checked={this.state.checkProject}
											onChange={() => this.handleCheckboxChange('Project')}
											style={{
												height: '20px',
												width: '20px',
												borderRadius: '4px',
												border: '1.5px solid #707070',
												backgroundColor: this.state.checkProject
													? '#9256D9'
													: 'none',
											}}
										/>
										<label className="create-task-checkbox-text">
											Project task
										</label>
									</div>
								</div>
							</div>
						)}
					</div>
					{this.state.nextState ? (
						<div className="bm-footer2">
							<a
								onClick={(e) => {
									this.setState({
										nextState: false,
									});
								}}
								className="crete-task-back"
							>
								{'< Back'}
							</a>

							<a
								className={
									this.isDisabled() ? 'add-edit-btn disabled' : 'add-edit-btn'
								}
								onClick={(e) => {
									if (this.state.nextState === false) {
										this.setState({
											nextState: true,
										});
									} else if (this.state.nextState === true) {
										if (!this.isDisabled()) {
											this.createTaskApiCall();
										}
									}
								}}
								style={{
									margin: '0px 15px',
									background: 'linear-gradient(90deg, #9256D9 0%, #5F55EC 100%)',
									color: '#fff',
								}}
							>
								{this.state.nextState ? 'Create Task' : 'Next  >'}
							</a>
						</div>
					) : (
						<div
							className="bm-footer"
							style={{
								justifyContent: 'flex-end',
							}}
						>
							<a
								className={
									this.isDisabled() ? 'add-edit-btn disabled' : 'add-edit-btn'
								}
								onClick={(e) => {
									if (this.state.nextState === false) {
										this.setState({
											nextState: true,
										});
									}
								}}
								style={{
									margin: '0px 15px',
									background: 'linear-gradient(90deg, #9256D9 0%, #5F55EC 100%)',
									color: '#fff',
									marginLeft: '0px',
								}}
							>
								{this.state.nextState ? 'Create Task' : 'Next  >'}
							</a>
						</div>
					)}
				</div>
			</Modal>
		);
	}
}
export default withRouter(CreateTask);
